import Component from '../abstracts/Component';

export default class AddToWishlistComponent extends Component {
  get SELECTORS() {
    return {
      addToWish: '.js-wishlist-cta',
      notAdded: '.js-addtowish',
      added: '.js-added-wish'
    };
  }

  get CLASSES() {
    return {
      show: 'show',
      on: 'icon-wishlist-on js-added-wish',
      off: 'icon-wishlist-off js-addtowish'
    };
  }

  constructor() {
    super();

    this.notAdded = $(this.SELECTORS.notAdded);
    this.added = $(this.SELECTORS.added);
    this.addToWish = $(this.SELECTORS.addToWish);
  }

  bindEvents() {
    let ctx = this;

    //click on wishlist
    $('body').on('click.addtowish', ctx.SELECTORS.notAdded, function (e) {
      e.preventDefault();
      e.stopPropagation();
      let $this = $(this);
      ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.addtowish, $this)
    });

    $('body').on('click.removefromwish', ctx.SELECTORS.added, function (e) {
      e.preventDefault();
      e.stopPropagation();
      let $this = $(this);
      ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.removefromwish, $this)
    });

    this.$on(
      this.$customEvents.PRODUCT_EVENTS.sizechanged,
      ({event, payload}) => {
        let code = $(payload.button).data('code');
        this.addToWish.data('code', code);
        this.log(code);
      }
    );

    this.$on(this.$customEvents.PRODUCT_EVENTS.addedtowish, (e) => {
      let code = $(e.payload).data('code');
      let $cta = $(e.payload);
      $cta.removeClass(this.CLASSES.off).addClass(this.CLASSES.on);
      $cta.data('href', `/action/miniwishlist/remove?productCode=${code}`);
    });

    this.$on(this.$customEvents.PRODUCT_EVENTS.removedfromwish, (e) => {
      let code = $(e.payload).data('code').toString();

      if (code.length > 13)
        code = code.substring(0, 13); //Remove color variant digit

      let $cta = '';
      if ($(e.payload).hasClass('js-wishlist-cta')) {
        $cta = $(e.payload);
      } else {
        $cta = $(`.js-wishlist-cta[data-code=${code}]`);
      }
      $cta
        .removeClass(this.CLASSES.on)
        .addClass(this.CLASSES.off);
      $cta.data('href', `/action/ajax/wishlist-add`);
    });
  }

  render() {
    this.bindEvents();
  }
}
